import styled from 'styled-components';

export const Label = styled('span')`
  color: ${({ theme }) => theme.color.darkerGray};
`;

export const SubLabel = styled('span')`
  color: ${({ theme }) => theme.color.mediumGrayRGBA(0.8)};
`;

export const Accordion = styled.div``;

interface AccordionHeaderProps {
  toggled?: boolean;
}

export const AccordionHeader = styled('div')<AccordionHeaderProps>`
  cursor: pointer;
  width: 100%;
  transition: background-color 0.2s ease-in-out;
  background-color: ${({ toggled, theme }) =>
    toggled ? theme.color.darkerGrayRGBA(0.05) : 'transparent'};
  padding: ${({ theme }) => theme.x1spacePx}px
    ${({ theme }) => theme.x2spacePx}px;
  > fieldset {
    > label {
      margin-bottom: 0;
    }
  }
  &:hover {
    background-color: ${({ theme }) => theme.color.brand01RGBA(0.2)};
  }
`;

export const AccordionHeaderLabel = styled.h4`
  margin: 0;
  user-select: none;
`;

export const AccordionBody = styled.div`
  padding: 1.6rem;
  display: block;
  animation: fadein 0.35s ease-in;
  font-size: 1rem;
  padding: 6rem 4rem;
`;

interface ChildContainerProps {
  duration: number;
  state: string;
}

export const ChildContainer = styled('div')<ChildContainerProps>`
  transition: max-height ${({ duration }) => duration}ms ease-in-out;
  overflow: hidden;
  max-height: ${({ state }) => {
    switch (state) {
      case 'entering':
        return 134;
      case 'entered':
        return 134;
      case 'exiting':
        return 0;
      case 'exited':
        return 0;
      default:
        return 0;
    }
  }}px;
`;
